import type ArticleLocal from '~/libs/interfaces/ArticleLocal'

export type ExternalArticleBoxItem = {
  title: string
  link: string
  description: string
  pubDate: string
  guid: string
  thumbnail?: { url: string; height: number; width: number }
  magazineName?: string
  magazineURL?: string
  measuring?: string
}

export type ExternalArticleBoxResponse = {
  title?: string
  link?: string
  description?: string
  language?: string
  pubDate?: string
  items: ExternalArticleBoxItem[]
}

function mapBoxItemToArticleLocal(item: ExternalArticleBoxItem): ArticleLocal {
  return {
    id: item.guid,
    title: item.title,
    perex: item.description,
    url: item.link,
    isVisible: true,
    previewAsset: item.thumbnail?.url
      ? { urlWithProtocol: item.thumbnail.url }
      : undefined,
    magazineName: item.magazineName,
    publishedDate: item.pubDate ? new Date(item.pubDate) : undefined,
  } as ArticleLocal
}

export const useExternalArticles = () => {
  const articles = ref<ArticleLocal[]>([])
  const isLoading = ref(true)

  const fetchArticles = async () => {
    isLoading.value = true
    try {
      const data = await $fetch<ExternalArticleBoxResponse>('/api/external-articles')
      articles.value = (data.items || []).map(mapBoxItemToArticleLocal)
    } catch {
      articles.value = []
    } finally {
      isLoading.value = false
    }
  }

  const getArticles = (limit?: number) => {
    if (limit) {
      return articles.value.slice(0, limit)
    }
    return articles.value
  }

  return {
    articles,
    isLoading,
    fetchArticles,
    getArticles,
  }
}
